export default {
  /**
   * @param {import('../app.js').App} _app
   */
  install(_app) {
    // Empty
  },
};